<template>
  <FormSelect
    :name="`${$t('meta.volume')} (${$t('meta.cubicMeter')})`"
    @input="$emit('input', $event)"
    :value="value"
    :required="required"
    :loading="!containerVolumes"
    :disabled="disabled"
    :options="containerVolumes"
    data-testid="order-form__target-container-volume-select"
  />
</template>

<script>
import FormSelect from '@/components/Form/Select/index.vue'

import containersApi from '@/api/container'

export default {
  name: 'VolumeSelect',
  components: { FormSelect },
  props: {
    value: { type: Number, default: null },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
  },
  data() {
    return {
      containerVolumes: [],
    }
  },
  async mounted() {
    this.containerVolumes = await containersApi.selectableTypeVolumes({ projects: true })
  },
}
</script>
